import Button from "@material-ui/core/Button";
import Drawer from "@material-ui/core/Drawer";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Helmet from "react-helmet";
import loader from "Assets/Gif/loader.gif";

import headersList from "Constants/headersList";
import withStyles from "@material-ui/core/styles/withStyles";
import { ResponsiveBarCanvas } from "@nivo/bar";
import { ResponsiveRadar } from "@nivo/radar";
import { ResponsiveScatterPlot } from "@nivo/scatterplot";
import { instance } from "Actions/AxiosInstance";
import { setPreview as setPreviewAction } from "Actions/commonAction";
import emp360 from "Assets/Svg/result360.svg";
import DefaultComp from "Component/DefaultComp/Defaultstatecomp";
import backArrow from "Assets/newicons/arrow/line-arrow/left/outline/line-arrow-left-outline-16px.svg";
import classNames from "classnames";
import { radioinputconverter } from "Component/DynamicForm/Fields/Radio";
import { selectinputconverter } from "Component/DynamicForm/Fields/Select";
import ProfilePicture from "Component/Thumbnail/ProfilePicture";
import uniq from "lodash/uniq";
import { withSnackbar } from "notistack";
import React from "react";
import uniqBy from "lodash/uniqBy";
import { connect } from "react-redux";
import StarRatingComponent from "Library/react-star-rating-component";
import { bindActionCreators } from "redux";
import { getFormattedImageLink } from "Utils";
import DynamicForm from "../../../../../Component/DynamicForm";
import DrawerHeader from "../../../../../Component/Headers/drawerHeader";
import Forms from "../Forms";
import { getCount } from "../Functions";
import { getAnomouNames, firstNames, lastNames } from "../names";
import "./index.scss";

const styles = () => ({
  TableRow: {
    borderRadius: 4,
  },
});

const getData = (q, threecodes, fourcodes, fivecodes) => {
  if (q.questioninputtypeid == 2) {
    const arr =
      q.questioninputoption &&
      q.questioninputoption.map((op, index) => {
        const obj =
          q.votescount &&
          q.votescount.find(
            (vote) => op.questioninputoptionid == vote.questioninputoptionid,
          );
        if (obj) {
          return {
            data: { ...op, ...obj, reviewquestionid: q.reviewquestionid },
            count: obj.count,
            name: `op${index + 1}`,
            type: "rating",
          };
        }
        return {
          data: { ...op, reviewquestionid: q.reviewquestionid },
          count: 0,
          name: `op${index + 1}`,
          type: "rating",
        };
      });
    return arr;
  } else {
    const getCountForEmoji = (id) => {
      if (id == 1) return threecodes;
      if (id == 2) return fourcodes;
      if (id == 3) return fivecodes;
    };
    const total =
      getCount(q.ratingscaletypeid) &&
      Array.from(
        Array(getCount(q.ratingscaletypeid)),
        (val, index1) => index1 + 1,
      );
    const arr =
      total &&
      total.map((num) => {
        const obj =
          q.votescount && q.votescount.find((vote) => num == vote.rating);
        if (obj) {
          return {
            data: { ...obj, reviewquestionid: q.reviewquestionid },
            count: obj.count,
            type: "rating",
            name:
              q.ratingtypeid == 1
                ? num
                : q.ratingtypeid == 2
                ? `${num} star`
                : getCountForEmoji(q.ratingscaletypeid) &&
                  `${String.fromCodePoint(
                    parseInt(
                      getCountForEmoji(q.ratingscaletypeid).find(
                        (emoji, i) => i + 1 == num,
                      ),
                      16,
                    ),
                  )}`,
          };
        }
        return {
          data: { reviewquestionid: q.reviewquestionid },
          count: "0",
          type: "rating",
          name:
            q.ratingtypeid == 1
              ? num
              : q.ratingtypeid == 2
              ? `${num} star`
              : getCountForEmoji(q.ratingscaletypeid) &&
                `${String.fromCodePoint(
                  parseInt(
                    getCountForEmoji(q.ratingscaletypeid).find(
                      (emoji, i) => i + 1 == num,
                    ),
                    16,
                  ),
                )}`,
        };
      });
    return arr;
  }
};

const getScatterData = (data) => {
  const arr = uniqBy(data, "participantemployeeid").map((x) => ({
    id: x.fullname || "Average",
    participantemployeeid: x.participantemployeeid,
    data: [
      {
        x: "",
        y: "",
      },
    ],
  }));
  const section1 =
    uniqBy(data, "reviewsectionid")[0] &&
    uniqBy(data, "reviewsectionid")[0].reviewsectionid;
  console.log("section1: ", section1);
  const section2 =
    uniqBy(data, "reviewsectionid")[1] &&
    uniqBy(data, "reviewsectionid")[1].reviewsectionid;
  console.log("section2: ", section2);
  data &&
    data.forEach((d) => {
      const index = arr.findIndex(
        (x) => x.participantemployeeid == d.participantemployeeid,
      );
      if (arr[index]) {
        if (arr[index].data.length > 0) {
          arr[index].data[0] = {
            x:
              d.reviewsectionid == section1
                ? d.averagerating
                : arr[index].data[0].x,
            y:
              d.reviewsectionid == section2
                ? d.averagerating
                : arr[index].data[0].y,
          };
        } else {
          arr[index].data.push({
            x: d.reviewsectionid == section1 ? d.averagerating : "",
            y: d.reviewsectionid == section2 ? d.averagerating : "",
          });
        }
      }
    });
  arr.filter((x, index) => {
    if (x.key == "Average") {
      arr.splice(index, 1);
      arr.push(x);
    }
  });
  return arr;
};

const getSpiderData = (data) => {
  const arr = [];
  data.forEach((d) => {
    const index = arr.findIndex((x) => x.competencyid == d.competencyid);
    const key = "Average";
    if (index == -1) {
      const objdata = {
        competencyid: d.competencyid,
        competencyname: d.competencyname,
        [d.fullname ? d.fullname : key]: d.averagerating,
      };
      const names = uniq(
        data &&
          data.map((data1) => (data1.fullname ? data1.fullname : "Average")),
      );
      names.forEach((name) => {
        if (!objdata[name]) {
          objdata[name] = "";
        }
      });
      arr.push(objdata);
    } else {
      arr[index][d.fullname ? d.fullname : key] = d.averagerating;
    }
  });
  console.log(arr);
  arr.filter((x, index) => {
    if (x.key == "Average") {
      arr.splice(index, 1);
      arr.push(x);
    }
  });
  return arr;
};

const RenderBar = ({
  data,
  keytype,
  selectedOptionid,
  selectedQuestionId,
  setOption,
}) => (
  <ResponsiveBarCanvas
    data={data}
    keys={["count"]}
    indexBy={keytype}
    margin={{ top: 50, right: 60, bottom: 50, left: 60 }}
    pixelRatio={1}
    padding={0.55}
    innerPadding={0}
    minValue="auto"
    maxValue="auto"
    groupMode="stacked"
    layout="vertical"
    reverse={false}
    colors={(d) => {
      if (
        d.index + 1 == selectedOptionid &&
        selectedQuestionId == d.data.data.reviewquestionid
      ) {
        return "#82bdff";
      }
      return "#d9dadb";
    }}
    // colorBy="rating"
    borderWidth={0}
    borderRadius={0}
    // borderColor={{ from: 'color', modifiers: [ [ 'darker', 1.6 ] ] }}
    enableLabel={true}
    // label={(d) => `${d.id}`}
    // axisTop={{ tickSize: 5, tickPadding: 5, tickRotation: 0, legend: '', legendOffset: 36 }}
    axisRight={null}
    axisBottom={{
      tickSize: 5,
      tickPadding: 5,
      tickRotation: 0,
      legend: "Ratings",
      legendPosition: "middle",
      legendOffset: 36,
    }}
    // axisLeft={{
    //   tickSize: 5,
    //   tickPadding: 5,
    //   tickRotation: 0,
    //   legend: 'Count',
    //   legendPosition: 'middle',
    //   legendOffset: -40,
    // }}
    axisLeft={null}
    onClick={(x, y) => {
      setOption(x);
    }}
    enableGridX={true}
    enableGridY={false}
    labelSkipWidth={12}
    labelSkipHeight={12}
    animate={true}
    motionStiffness={90}
    motionDamping={15}
    // labelTextColor={{ from: 'color', modifiers: [ [ 'darker', 1.6 ] ] }}
    isInteractive={true}
  />
);

class Results extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      DrawerOpen: false,
      permissions: { editable: true, readonly: true },
      empform: null,
      selectedForm: null,
      details: [],
      detailedView: false,
      selectedOptionid: null,
      selectedQuestionId: null,
      selectedVotes: null,
      selectedQuestion: null,
      open: false,
      comments: [],
      allvotes: [],
      spiderdata: [],
      scatterdata: [],
      isTextualAnswers: false,
    };

    this.editForm = this.editForm.bind(this);
    this.getDetails = this.getDetails.bind(this);
    this.setOption = this.setOption.bind(this);
    this.showComments = this.showComments.bind(this);
    this.showAllVotes = this.showAllVotes.bind(this);
  }

  componentDidMount() {}

  editForm(data) {
    this.setState(
      {
        selectedForm: data,
      },
      () => {
        instance
          .get(`perform/getfeedbackform/${data.empreviewdetailid}`)
          .then((result) => {
            this.setState(
              {
                empform: result.data.result[0],
              },
              () => {
                instance
                  .get(`perform/competencychart/${data.empreviewformid}`)
                  .then((result1) => {
                    const arr = result1.data.result.map((x) => ({
                      ...x,
                      bfullname: x.fullname,
                    }));
                    const newarr = [];
                    const getName = () => {
                      const fn = `${
                        firstNames[
                          Math.floor(Math.random() * firstNames.length)
                        ]
                      } ${
                        lastNames[Math.floor(Math.random() * lastNames.length)]
                      }`;
                      if (newarr.find((emp) => emp.fullname == fn)) {
                        getName();
                      }
                      return fn;
                    };
                    arr.forEach((x) => {
                      if (x.isfeedbackanonymous) {
                        const splitname = x.fullname.split("-");
                        const findexist = newarr.find(
                          (emp) => emp.bfullname == x.fullname,
                        );
                        const obj = {
                          ...x,
                          fullname: findexist
                            ? findexist.fullname
                            : `${getName()}-${splitname[2]}`,
                        };
                        newarr.push(obj);
                      } else {
                        newarr.push(x);
                      }
                    });
                    console.log("newarr: ", newarr);
                    this.setState({
                      spiderdata: newarr,
                    });
                    instance
                      .get(`perform/sectionchart/${data.empreviewformid}/10`)
                      .then((result2) => {
                        this.setState({
                          scatterdata: result2.data.result,
                        });
                      })
                      .catch((error) => {
                        this.props.enqueueSnackbar(
                          error.response
                            ? error.response.data.error.message
                            : error.message,
                          { variant: "error" },
                        );
                      });
                  })
                  .catch((error) => {
                    this.props.enqueueSnackbar(
                      error.response
                        ? error.response.data.error.message
                        : error.message,
                      { variant: "error" },
                    );
                  });
              },
            );
          })
          .catch((error) => {
            this.props.enqueueSnackbar(
              error.response
                ? error.response.data.error.message
                : error.message,
              { variant: "error" },
            );
          });
      },
    );
  }

  getDetails() {
    const { empform, selectedForm } = this.state;
    // this.props.startLoadProcess();
    instance
      .get(
        `perform/getformdetailedview/${
          selectedForm ? selectedForm.empreviewformid : null
        }/${empform ? empform.reviewformid : null}`,
      )
      .then((result) => {
        this.setState(
          {
            details: result.data.result,
            detailedView: true,
          },
          () => {
            // this.props.stopLoadProcess();
          },
        );
      })
      .catch((error) => {
        // this.props.stopLoadProcess();
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  setOption(node) {
    this.setState({
      selectedQuestionId: node.data.data.reviewquestionid,
      selectedOptionid: node.index + 1,
      selectedVotes: node.value,
    });
  }

  showComments(q, isTextualAnswers) {
    const { selectedForm } = this.state;
    console.log(this.state.comments);
    instance
      .get(
        `perform/seeallcomment/${
          selectedForm ? selectedForm.empreviewformid : null
        }/${q ? q.reviewquestionid : null}`,
      )
      .then((result) => {
        this.setState({
          selectedQuestion: q,
          isTextualAnswers,
          comments: getAnomouNames(result.data.result),
          open: true,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  showAllVotes(q) {
    const { selectedForm } = this.state;
    instance
      .get(
        `perform/seeallvotes/${
          selectedForm ? selectedForm.empreviewformid : null
        }/${q ? q.reviewquestionid : null}`,
      )
      .then((result) => {
        this.setState({
          selectedQuestion: q,
          allvotes: getAnomouNames(result.data.result),
          open: true,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  toggleDrawer = (side, open, flag) => () => {
    if (flag == "isComments") {
      this.setState({
        isComments: true,
        isTextualAnswers: false,
        isVotes: false,
        [side]: open,
      });
    } else if (flag == "isTextualAnswers") {
      this.setState({
        isComments: false,
        isTextualAnswers: true,
        isVotes: false,
        [side]: open,
      });
    } else if (flag == "isVotes") {
      this.setState({
        isComments: false,
        isTextualAnswers: false,
        isVotes: true,
        [side]: open,
      });
    } else if (!flag) {
      this.setState({
        [side]: open,
      });
    }
  };

  render() {
    const {
      classes,
      performcycles,
      cycleid,
      isSpecialAccess,
      forms,
      threecodes,
      fourcodes,
      fivecodes,
      typeone,
      typetwo,
      typethree,
      typefour,
      typefive,
      value,
    } = this.props;
    const {
      empform,
      detailedView,
      details,
      selectedQuestionId,
      selectedOptionid,
      selectedVotes,
      comments,
      allvotes,
      scatterdata,
    } = this.state;
    const selectedcycle = performcycles.find(
      (c) => c.performcycledurationid == cycleid,
    );
    const selectedQuestion =
      details &&
      details.find((det) => det.reviewquestionid == selectedQuestionId);
    const totalcompetencies = uniqBy(this.state.spiderdata, "competencyid");
    const totalsections = uniqBy(this.state.scatterdata, "reviewsectionid");

    const getRatingDeatil = () => {
      if (selectedQuestion && selectedQuestion.questioninputtypeid == 2) {
        const selectedOption = selectedQuestion.questioninputoption.find(
          (op, index) => index + 1 == selectedOptionid,
        );
        return selectedOption && selectedOption.optionname;
      } else if (selectedQuestion) {
        if (selectedQuestion.ratingscaletypeid == 1) {
          const name = typeone.find(
            (n, index) => index + 1 == selectedOptionid,
          );
          return name;
        } else if (selectedQuestion.ratingscaletypeid == 2) {
          const name = typetwo.find(
            (n, index) => index + 1 == selectedOptionid,
          );
          return name;
        } else if (selectedQuestion.ratingscaletypeid == 3) {
          const name = typethree.find(
            (n, index) => index + 1 == selectedOptionid,
          );
          return name;
        } else if (selectedQuestion.ratingscaletypeid == 4) {
          const name = typefour.find(
            (n, index) => index + 1 == selectedOptionid,
          );
          return name;
        } else if (selectedQuestion.ratingscaletypeid == 5) {
          const name = typefive.find(
            (n, index) => index + 1 == selectedOptionid,
          );
          return name;
        }
      }
    };

    const getPercentage = () => {
      const total =
        selectedQuestion &&
        selectedQuestion.votescount &&
        selectedQuestion.votescount
          .map((x) => x.count)
          .reduce((a, b) => parseInt(a) + parseInt(b), 0);
      return total && selectedVotes
        ? parseFloat(parseInt(selectedVotes) / total).toFixed(2) * 100
        : "";
    };

    const getCountForEmoji = (id) => {
      if (id == 1) return threecodes;
      if (id == 2) return fourcodes;
      if (id == 3) return fivecodes;
    };

    return (
      <div>
        {/* <Helmet>
          <title>{headersList.Perform.EmployeeReviews.header}</title>
        </Helmet> */}
        {!this.props.datareceived ? (
          <div>
            <img className="loader" src={loader} />
          </div>
        ) : (
          <div>
            {empform ? (
              <Grid container>
                <Grid item md={12} sm={12} style={{ padding: 2 }}>
                  <Paper
                    className="rounded-rectangle-paper padding16"
                    style={{ height: "auto" }}
                  >
                    <div className="margin-bottom-16">
                      <span
                        className="floatleft margin-right-16 cursor-pointer"
                        onClick={() =>
                          this.setState({
                            empform: null,
                            detailedView: false,
                            details: [],
                            selectedForm: null,
                            selectedVotes: null,
                            selectedOptionid: null,
                            selectedQuestionId: null,
                          })
                        }
                      >
                        <img src={backArrow}></img>
                      </span>
                      <span className="floatleft normal-dark-secondary t-bold">
                        {empform.formtitle}
                      </span>
                      <div className="clear-float"></div>
                    </div>
                    <Grid container>
                      <Grid item md={4} sm={12}>
                        <p className="normal-dark-secondary t-bold margin-bottom-4 padding-top-8">
                          {detailedView ? "Detailed view" : "Overview"}{" "}
                        </p>
                        {detailedView ? (
                          <p
                            className="extra-small-blue cursor-pointer"
                            style={{ textDecoration: "underline" }}
                            onClick={() =>
                              this.setState({
                                selectedVotes: null,
                                selectedOptionid: null,
                                selectedQuestionId: null,
                                detailedView: false,
                                details: [],
                              })
                            }
                          >
                            Switch to "Overview"
                          </p>
                        ) : (
                          <p
                            className="extra-small-blue cursor-pointer"
                            style={{ textDecoration: "underline" }}
                            onClick={this.getDetails}
                          >
                            Switch to "Detailed view"
                          </p>
                        )}
                      </Grid>
                    </Grid>
                  </Paper>
                </Grid>
                <Grid
                  item
                  md={12}
                  sm={12}
                  style={{ padding: 2 }}
                  className="margin-top-16"
                >
                  {detailedView ? (
                    <div>
                      {details &&
                        details.map((q, index) => (
                          <div className="margin-bottom-16">
                            <p className="extra-small-dark t-bold margin-bottom-4">
                              {q.sectionname} / {q.focusareaname} {" ("}
                              {q.competencyname}
                              {")"}
                            </p>
                            <Paper className="rounded-rectangle-paper padding16 margin-bottom-16">
                              <p className="small-dark margin-bottom-16">
                                {index + 1}. {q.question}
                              </p>
                              {!q.sizetypeid ? (
                                <Grid container>
                                  <Grid item sm={12} md={6}>
                                    <div style={{ height: 220 }}>
                                      <RenderBar
                                        data={getData(
                                          q,
                                          threecodes,
                                          fourcodes,
                                          fivecodes,
                                        )}
                                        keytype={"name"}
                                        selectedQuestionId={selectedQuestionId}
                                        selectedOptionid={selectedOptionid}
                                        setOption={this.setOption}
                                      />
                                    </div>
                                  </Grid>
                                  <Grid
                                    item
                                    sm={12}
                                    md={6}
                                    style={{
                                      borderLeft: "1px solid #D9DADB",
                                      paddingLeft: 24,
                                    }}
                                  >
                                    {selectedQuestionId ==
                                      q.reviewquestionid && (
                                      <div>
                                        <p className="small-dark margin-bottom-16 t-bold">
                                          {selectedVotes} votes (
                                          {getPercentage()}
                                          %)
                                        </p>
                                        <p className="small-dark-secondary margin-bottom-16">
                                          {getRatingDeatil()}
                                        </p>
                                        <div
                                          className="floatleft cursor-pointer"
                                          onClick={() => this.showComments(q)}
                                        >
                                          <p className="extra-small-blue margin-bottom-16 t-bold">
                                            See all comments
                                          </p>
                                        </div>
                                        <div
                                          className="floatright cursor-pointer"
                                          onClick={() => this.showAllVotes(q)}
                                        >
                                          <p className="extra-small-blue margin-bottom-16 t-bold">
                                            See all votes
                                          </p>
                                        </div>
                                      </div>
                                    )}
                                  </Grid>
                                </Grid>
                              ) : (
                                <Grid>
                                  <Grid item sm={12} md={4}>
                                    <Button
                                      className="btn btn-secondary-md-blue margin-right-16"
                                      variant="contained"
                                      style={{ width: 300 }}
                                      onClick={() => this.showComments(q, true)}
                                    >
                                      Click here to see textual answers
                                    </Button>
                                  </Grid>
                                </Grid>
                              )}
                            </Paper>
                          </div>
                        ))}
                    </div>
                  ) : (
                    <div>
                      {totalcompetencies && totalcompetencies.length > 2 ? (
                        <Paper className="rounded-rectangle-paper padding16 margin-bottom-16">
                          <div>
                            <p className="normal-dark-secondary t-bold margin-bottom-4 padding-top-8">
                              Spider Graph
                            </p>
                            <p className="small-dark-secondary margin-bottom-24">
                              This graph will help you guage the changes in your
                              ratings in the past.
                            </p>
                            <div
                              style={{ height: 500 }}
                              className="radar-outer"
                            >
                              <ResponsiveRadar
                                data={
                                  this.state.spiderdata &&
                                  getSpiderData(this.state.spiderdata)
                                }
                                keys={uniq(
                                  this.state.spiderdata &&
                                    this.state.spiderdata.map((data) =>
                                      data.fullname ? data.fullname : "Average",
                                    ),
                                )}
                                // keys={["Shubham Agarwal", "Bhuvan bam", "Average"]}
                                indexBy="competencyname"
                                maxValue="auto"
                                margin={{
                                  top: 70,
                                  right: 80,
                                  bottom: 70,
                                  left: 80,
                                }}
                                curve="linearClosed"
                                borderWidth={2}
                                borderColor={{ from: "color" }}
                                gridLevels={5}
                                gridShape="circular"
                                gridLabelOffset={36}
                                enableDots={true}
                                dotSize={10}
                                dotColor={{ theme: "background" }}
                                dotBorderWidth={2}
                                dotBorderColor={{ from: "color" }}
                                enableDotLabel={true}
                                dotLabel="value"
                                dotLabelYOffset={-12}
                                colors={{ scheme: "nivo" }}
                                fillOpacity={0.25}
                                blendMode="multiply"
                                animate={true}
                                motionStiffness={90}
                                motionDamping={15}
                                isInteractive={true}
                                legends={[
                                  {
                                    anchor: "top-left",
                                    direction: "column",
                                    translateX: -50,
                                    translateY: -40,
                                    itemWidth: 80,
                                    itemHeight: 20,
                                    itemTextColor: "#999",
                                    symbolSize: 12,
                                    symbolShape: "circle",
                                    effects: [
                                      {
                                        on: "hover",
                                        style: {
                                          itemTextColor: "#000",
                                        },
                                      },
                                    ],
                                  },
                                ]}
                              />
                            </div>
                          </div>
                        </Paper>
                      ) : (
                        <Paper className="rounded-rectangle-paper padding16 margin-bottom-16">
                          <p className="text-align-center">
                            {" "}
                            Spider graph is only available when more than 2
                            Competencies are available in a review form.
                          </p>
                        </Paper>
                      )}
                      {totalsections && totalsections.length > 1 ? (
                        <Paper className="rounded-rectangle-paper padding16">
                          <div>
                            <p className="normal-dark-secondary t-bold margin-bottom-4 padding-top-8">
                              Scatter Graph
                            </p>
                            <p className="small-dark-secondary margin-bottom-24">
                              This graph shows distribution of section wise
                              ratings
                            </p>
                            <div
                              style={{ height: 500 }}
                              className="radar-outer"
                            >
                              <ResponsiveScatterPlot
                                data={getScatterData(this.state.scatterdata)}
                                margin={{
                                  top: 40,
                                  right: 240,
                                  bottom: 70,
                                  left: 50,
                                }}
                                xScale={{ type: "linear", min: 0, max: "auto" }}
                                // xFormat={function(e){return e+" kg"}}
                                yScale={{ type: "linear", min: 0, max: "auto" }}
                                // yFormat={function(e){return e+" cm"}}
                                blendMode="multiply"
                                axisTop={null}
                                useMesh={false}
                                axisRight={null}
                                axisBottom={{
                                  orient: "bottom",
                                  tickSize: 5,
                                  tickPadding: 5,
                                  tickRotation: 0,
                                  legend: `${this.state.scatterdata[3].sectionname} (x)`,
                                  legendPosition: "middle",
                                  legendOffset: 46,
                                }}
                                axisLeft={{
                                  orient: "left",
                                  tickSize: 5,
                                  tickPadding: 5,
                                  tickRotation: 0,
                                  legend: `${this.state.scatterdata[3].sectionname} (y)`,
                                  legendPosition: "middle",
                                  legendOffset: -40,
                                }}
                                legends={[
                                  {
                                    anchor: "bottom-right",
                                    direction: "column",
                                    justify: false,
                                    translateX: 100,
                                    translateY: 0,
                                    itemWidth: 100,
                                    itemHeight: 20,
                                    itemsSpacing: 5,
                                    itemDirection: "left-to-right",
                                    symbolSize: 12,
                                    symbolShape: "circle",
                                    effects: [
                                      {
                                        on: "hover",
                                        style: {
                                          itemOpacity: 1,
                                        },
                                      },
                                    ],
                                  },
                                ]}
                              />
                            </div>
                          </div>
                        </Paper>
                      ) : (
                        <Paper className="rounded-rectangle-paper padding16">
                          <p className="text-align-center">
                            Scatter graph is only available when 2 sections are
                            available in a review form.{" "}
                          </p>
                        </Paper>
                      )}
                    </div>
                  )}
                </Grid>
              </Grid>
            ) : (
              <div className="thin-scroll">
                {forms.length > 0 ? (
                  <Forms
                    selectedcycle={selectedcycle}
                    forms={forms}
                    openForm={this.editForm}
                    getForms={this.props.getForms}
                    isSpecialAccess={isSpecialAccess}
                    value={value}
                    HelperSliderFlag={this.props.HelperSliderFlag}
                  />
                ) : (
                  <div
                    style={{ height: "77vh" }}
                    className="position-rel margin-top-16"
                  >
                    <DefaultComp
                      //  text={this.getText()}
                      heading={"There are no results!"}
                      subheading={
                        "Results will appear once the review forms have been released."
                      }
                      imageSrc={emp360}
                    />
                  </div>
                )}
              </div>
            )}
          </div>
        )}

        <Drawer
          anchor="right"
          open={this.state.open}
          onClose={() =>
            this.setState({
              open: false,
              isTextualAnswers: false,
              selectedQuestion: null,
              comments: [],
              allvotes: [],
            })
          }
          classes={{
            paper: classNames(classes.drawerPaper, "planner-drawer padding15"),
          }}
        >
          <DrawerHeader
            header={
              this.state.isTextualAnswers
                ? "Textual answers"
                : comments.length > 0
                ? "Comments"
                : "All votes"
            }
            isbackarrow={false}
            closeDrawer={() =>
              this.setState({
                open: false,
                isTextualAnswers: false,
                selectedQuestion: null,
                comments: [],
                allvotes: [],
              })
            }
          />
          {comments.length > 0 ? (
            <div
              className="thin-scroll"
              style={{ height: "96vh", overflowY: "auto", paddingRight: 15 }}
              // onScroll={this.handleScroll1}
            >
              <div className="margin-bottom-16">
                <Grid container className="margin-top-8">
                  <Grid item xs={12} md={12} sm={12}>
                    <p className="extra-small-dark-secondary margin-bottom-8">
                      {this.state.selectedQuestion &&
                        this.state.selectedQuestion.sectionname}{" "}
                      /{" "}
                      {this.state.selectedQuestion &&
                        this.state.selectedQuestion.focusareaname}{" "}
                      {" ("}
                      {this.state.selectedQuestion.competencyname}
                      {")"}
                    </p>

                    <p className="normal-dark-secondary margin-bottom-8">
                      {this.state.selectedQuestion &&
                        this.state.selectedQuestion.question}
                    </p>
                    {/* <div className="margin-bottom-16">
                      <SearchSq
                        placeholder="Search employee"
                        value={this.state.searchValue}
                        onChange={this.handleSearch}
                      />
                    </div> */}
                    {comments.map((c) => (
                      <div
                        style={{
                          borderBottom: "1px solid #d9dadb",
                          padding: "8px 0px",
                        }}
                      >
                        <ProfilePicture
                          src={getFormattedImageLink(c.imagepath)}
                          height="32"
                        />
                        <span className="small-dark-secondary margin-left-16">
                          {c.fullname}
                        </span>
                        <p className="normal-dark-secondary margin-top-8">
                          {c.feedback}
                        </p>
                      </div>
                    ))}
                  </Grid>
                </Grid>
              </div>
            </div>
          ) : (
            <div className="small-dark-secondary text-align-center">
              Comments not available
            </div>
          )}
          {allvotes.length ? (
            <div
              className="thin-scroll"
              style={{ height: "96vh", overflowY: "auto", paddingRight: 15 }}
              // onScroll={this.handleScroll1}
            >
              <div className="margin-bottom-16">
                <Grid container className="margin-top-8">
                  <Grid item xs={12} md={12} sm={12}>
                    <p className="extra-small-dark-secondary margin-bottom-8">
                      {this.state.selectedQuestion &&
                        this.state.selectedQuestion.sectionname}{" "}
                      /{" "}
                      {this.state.selectedQuestion &&
                        this.state.selectedQuestion.focusareaname}{" "}
                      {" ("}
                      {this.state.selectedQuestion.competencyname}
                      {")"}
                    </p>

                    <p className="normal-dark-secondary margin-bottom-8">
                      {this.state.selectedQuestion &&
                        this.state.selectedQuestion.question}
                    </p>
                    {/* <div className="margin-bottom-16">
                      <SearchSq
                        placeholder="Search employee"
                        value={this.state.searchValue}
                        onChange={this.handleSearch}
                      />
                    </div> */}
                    {allvotes.map((vote) => (
                      <div
                        style={{
                          borderBottom: "1px solid #d9dadb",
                          padding: "8px 0px",
                        }}
                      >
                        <ProfilePicture
                          src={getFormattedImageLink(vote.imagepath)}
                          height="32"
                        />
                        <span className="small-dark-secondary margin-left-16">
                          {vote.fullname}
                        </span>
                        <div style={{ margin: "16px 16px 16px 0px" }}>
                          {this.state.selectedQuestion &&
                            this.state.selectedQuestion.ratingtypeid == 1 &&
                            getCount(
                              this.state.selectedQuestion.ratingscaletypeid,
                            ) &&
                            Array.from(
                              Array(
                                getCount(
                                  this.state.selectedQuestion.ratingscaletypeid,
                                ),
                              ),
                              (val, index1) => index1 + 1,
                            ).map((num) => (
                              <div className="floatleft">
                                <div
                                  className={
                                    vote.rating == num
                                      ? "rating-scale-points-selected"
                                      : "rating-scale-points"
                                  }
                                >
                                  <span>{num}</span>
                                </div>
                                <div className="clear-float"></div>
                              </div>
                            ))}
                          {this.state.selectedQuestion &&
                            this.state.selectedQuestion.ratingtypeid == 2 &&
                            getCount(
                              this.state.selectedQuestion.ratingscaletypeid,
                            ) && (
                              <div className="floatleft">
                                <StarRatingComponent
                                  name="rate1"
                                  starCount={getCount(
                                    this.state.selectedQuestion
                                      .ratingscaletypeid,
                                  )}
                                  value={vote.rating}
                                />
                              </div>
                            )}
                          {this.state.selectedQuestion &&
                            this.state.selectedQuestion.ratingtypeid == 3 &&
                            getCountForEmoji(
                              this.state.selectedQuestion.ratingscaletypeid,
                            ) &&
                            getCountForEmoji(
                              this.state.selectedQuestion.ratingscaletypeid,
                            ).map((emoji, index1) => (
                              <div className="floatleft">
                                <div
                                  className={
                                    vote.rating == index1 + 1
                                      ? "rating-scale-points-selected"
                                      : "rating-scale-points"
                                  }
                                >
                                  {String.fromCodePoint(parseInt(emoji, 16))}
                                </div>
                                <div className="clear-float"></div>
                              </div>
                            ))}
                          {this.state.selectedQuestion &&
                            this.state.selectedQuestion.questioninputtypeid ==
                              2 &&
                            this.state.selectedQuestion.questioninputoption &&
                            this.state.selectedQuestion.questioninputoption.map(
                              (op) => (
                                <div>
                                  <span className="floatleft margin-right-8">
                                    <DynamicForm
                                      className="width50"
                                      fields={radioinputconverter({
                                        value:
                                          vote.questioninputoptionid &&
                                          op.questioninputoptionid ==
                                            vote.questioninputoptionid
                                            ? true
                                            : false,
                                        placeholder: "",
                                        label: "",
                                        disabled: true,
                                      })}
                                      onChange={() => {}}
                                    />
                                  </span>
                                  <span className="small-dark-secondary margin-bottom-8">
                                    {op.optionname}
                                  </span>
                                  <div className="clear-float"></div>
                                </div>
                              ),
                            )}
                          <div className="clear-float"></div>
                        </div>
                      </div>
                    ))}
                  </Grid>
                </Grid>
              </div>
            </div>
          ) : (
            <div className="small-dark-secondary text-align-center">
              Votes not available
            </div>
          )}
        </Drawer>
      </div>
    );
  }
}
const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setPreview: setPreviewAction,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(Results)));
